import CommunicationPreferences from ".";

export default function CommunicationPreferencesExamples() {
  return <CommunicationPreferences />;
}
